import React from 'react';
import { Container, Illustration, Subtitle } from './styles';
import { BdsButton, BdsGrid, BdsTypo } from 'blip-ds/dist/blip-ds-react';

interface EmptyStateProps {
  primaryButton: {
    label: string;
    onClick: () => void;
  };
  outlineButton?: {
    label: string;
    onClick: () => void;
  };
  title: string;
  subtitle: string;
  illustrationName?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  primaryButton,
  outlineButton,
  title,
  subtitle,
  illustrationName = 'folder-3',
}) => {
  return (
    <Container direction="column" align-items="center" gap="3" padding="3" justify-content="center">
      <Illustration name={illustrationName} type="spots" />
      <BdsGrid direction="column" gap="1" align-items="center" justify-content="center">
        <BdsTypo variant="fs-20" bold="bold" margin={false}>
          {title}
        </BdsTypo>
        <Subtitle>
          <BdsTypo variant="fs-14">{subtitle}</BdsTypo>
        </Subtitle>
      </BdsGrid>
      <BdsGrid gap="2">
        <BdsButton onClick={primaryButton.onClick}>{primaryButton.label}</BdsButton>
        {outlineButton && (
          <BdsButton variant="outline" onClick={outlineButton.onClick}>
            {outlineButton.label}
          </BdsButton>
        )}
      </BdsGrid>
    </Container>
  );
};

export default EmptyState;
